import React from "react";
import { NoResultContainer, StyledH1, Hal, Wraps } from "./styled";
import forOfor from "../../../components/Assets/404.png";

function NoResult() {
  return (
    <Wraps>
      <StyledH1>Ooops</StyledH1>
      <Hal src={forOfor} alt="HAL 9000 is alive" />
      <NoResultContainer>
        <StyledH1>404<br/>
        Strona nie istnieje </StyledH1>
      </NoResultContainer>
    </Wraps>
  );
}

export default NoResult;
